module.exports = __webpack_public_path__ + "img/4.494c605f.svg";